import { Array, Number, Record, String, Undefined } from "runtypes";
import { clean } from "./clean";
import { PERSONABLE_COURSEENROLLMENT_COLLECTION } from "./collections";
import { CourseName } from "./course";
import { currentCourse } from "./current";
import { SectionName } from "./section";
export const CourseEnrollment = CourseName.And(
  Record({
    count: Number,
    path: String,
    students: Array(String)
  })
);
export const loadCurrentCourseEnrollment = async (db, courseName = currentCourse) => {
  const { department, number, semester, year } = courseName;
  return CourseEnrollment.Or(Undefined).check(
    clean(
      await db.collection(PERSONABLE_COURSEENROLLMENT_COLLECTION).findOne({ department, number, semester, year, left: { $exists: false } })
    )
  );
};
export const SectionEnrollment = SectionName.And(
  Record({
    count: Number,
    path: String,
    students: Array(String)
  })
);
//# sourceMappingURL=enrollment.js.map
